/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";
import type { ShipmentReportInvoiceWarningState } from "./ShipmentReportInvoiceWarningState";
import {
  ShipmentReportInvoiceWarningStateFromJSON,
  ShipmentReportInvoiceWarningStateFromJSONTyped,
  ShipmentReportInvoiceWarningStateToJSON,
  ShipmentReportInvoiceWarningStateToJSONTyped,
} from "./ShipmentReportInvoiceWarningState";
import type { ShipmentReportSettlementStatus } from "./ShipmentReportSettlementStatus";
import {
  ShipmentReportSettlementStatusFromJSON,
  ShipmentReportSettlementStatusFromJSONTyped,
  ShipmentReportSettlementStatusToJSON,
  ShipmentReportSettlementStatusToJSONTyped,
} from "./ShipmentReportSettlementStatus";
import type { TransitTimeSourceType } from "./TransitTimeSourceType";
import {
  TransitTimeSourceTypeFromJSON,
  TransitTimeSourceTypeFromJSONTyped,
  TransitTimeSourceTypeToJSON,
  TransitTimeSourceTypeToJSONTyped,
} from "./TransitTimeSourceType";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";
import type { ShipmentReportQuoteSummary } from "./ShipmentReportQuoteSummary";
import {
  ShipmentReportQuoteSummaryFromJSON,
  ShipmentReportQuoteSummaryFromJSONTyped,
  ShipmentReportQuoteSummaryToJSON,
  ShipmentReportQuoteSummaryToJSONTyped,
} from "./ShipmentReportQuoteSummary";

/**
 *
 * @export
 * @interface ShipmentReportWithShipment
 */
export interface ShipmentReportWithShipment {
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  shipmentHash?: string;
  /**
   *
   * @type {ShipmentState}
   * @memberof ShipmentReportWithShipment
   */
  state?: ShipmentState;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentReportWithShipment
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  booked?: boolean;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deletedDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  proNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentReportWithShipment
   */
  quotedAt?: OffsetDateTime;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentReportWithShipment
   */
  pickupDate?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentReportWithShipment
   */
  pickupDateDescription?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  distanceMiles?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  companyLeadSource?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  companyUtmCampaignId?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentReportWithShipment
   */
  companyCreationDate?: LocalDate;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  numberOfShipmentsCompanyBooked?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  companyShipmentFrequency?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  numberCustomerInvoices?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  numberCarrierInvoices?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  numberCarrierCreditNotes?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  moneyInCad?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  moneyOutCad?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  originalQuote?: number;
  /**
   *
   * @type {ShipmentReportSettlementStatus}
   * @memberof ShipmentReportWithShipment
   */
  settlementStatus?: ShipmentReportSettlementStatus;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  profit?: number;
  /**
   *
   * @type {ShipmentReportInvoiceWarningState}
   * @memberof ShipmentReportWithShipment
   */
  invoiceWarningState?: ShipmentReportInvoiceWarningState;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupPostalCode?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupCity?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupState?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupCityState?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof ShipmentReportWithShipment
   */
  pickupCountry?: CountryCode;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  pickupLat?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  pickupLng?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryPostalCode?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryCityState?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryState?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof ShipmentReportWithShipment
   */
  deliveryCountry?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryCity?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  deliveryLat?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  deliveryLng?: number;
  /**
   *
   * @type {Array<ShipmentReportQuoteSummary>}
   * @memberof ShipmentReportWithShipment
   */
  quotes?: Array<ShipmentReportQuoteSummary>;
  /**
   *
   * @type {ShipmentReportQuoteSummary}
   * @memberof ShipmentReportWithShipment
   */
  fastestQuote?: ShipmentReportQuoteSummary;
  /**
   *
   * @type {ShipmentReportQuoteSummary}
   * @memberof ShipmentReportWithShipment
   */
  lowestQuote?: ShipmentReportQuoteSummary;
  /**
   *
   * @type {ShipmentReportQuoteSummary}
   * @memberof ShipmentReportWithShipment
   */
  bookedQuote?: ShipmentReportQuoteSummary;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  manualQuotingRequested?: boolean;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof ShipmentReportWithShipment
   */
  lineItems?: Array<LineItem>;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  lineItemDescription?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  totalHandlingUnits?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  totalWeight?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  totalVolume?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  density?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  freightClass?: string;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  insuranceRequested?: boolean;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  insuranceAmount?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof ShipmentReportWithShipment
   */
  insuranceCurrency?: CurrencyCode;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  standardDryVanLinearFeet?: number;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsDeliveryAppointment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsLiftgatePickup?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsLiftgateDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsResidentialPickup?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsResidentialDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsInsidePickup?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  needsInsideDelivery?: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentReportWithShipment
   */
  bookedAt?: OffsetDateTime;
  /**
   *
   * @type {Array<string>}
   * @memberof ShipmentReportWithShipment
   */
  problems?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShipmentReportWithShipment
   */
  tags?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  insurancePriceCad?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  serviceIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  billOfLadingNumber?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  linearFeetOverride?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  margin?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  marginInsuranceFree?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupReferenceNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryReferenceNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  carrierPickupNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  trackingId?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  emergencyContactName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  emergencyContactPhoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupBoothNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryBoothNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  advanceInterlineProNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  beyondInterlineProNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  bookedBy?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentReportWithShipment
   */
  actualDeliveryDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupBusinessName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupLocationType?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupNotes?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupAddress1?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupAddress2?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryBusinessName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryLocationType?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryNotes?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryAddress1?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryAddress2?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentReportWithShipment
   */
  companyFirstQuotedAt?: LocalDate;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  dangerous?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  protectFromFreezing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  invoiceAuditExisted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  invoiceAuditOpen?: boolean;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupDistributionWarehouseBrand?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryDistributionWarehouseBrand?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupRegion?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryRegion?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupSubregion?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliverySubregion?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  pickupMetroArea?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  deliveryMetroArea?: string;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  opportunityCad?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  earliestTransitDaysAtQuoting?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  latestTransitDaysAtQuoting?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  actualTransitDays?: number;
  /**
   *
   * @type {TransitTimeSourceType}
   * @memberof ShipmentReportWithShipment
   */
  transitTimeSource?: TransitTimeSourceType;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  longestDimensionInches?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  quoteQualityScore?: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  couponUsedAmount?: number;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  additionalChargeApplied?: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentReportWithShipment
   */
  bookedAtAssignedTo?: string;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  shipmentEverHadClaim?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  shipmentCurrentlyHasOpenClaim?: boolean;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  targetFreightMargin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentReportWithShipment
   */
  perfect?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ShipmentReportWithShipment
   */
  imperfectionReasons?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ShipmentReportWithShipment
   */
  insuranceCostCad?: number;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  erapPlanNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  erapPhoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentReportWithShipment
   */
  tdgResponsibleName?: string;
  /**
   *
   * @type {Shipment}
   * @memberof ShipmentReportWithShipment
   */
  shipment: Shipment;
}

/**
 * Check if a given object implements the ShipmentReportWithShipment interface.
 */
export function instanceOfShipmentReportWithShipment(
  value: object,
): value is ShipmentReportWithShipment {
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  return true;
}

export function ShipmentReportWithShipmentFromJSON(
  json: any,
): ShipmentReportWithShipment {
  return ShipmentReportWithShipmentFromJSONTyped(json, false);
}

export function ShipmentReportWithShipmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentReportWithShipment {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    shipmentHash:
      json["shipmentHash"] == null ? undefined : json["shipmentHash"],
    state:
      json["state"] == null ? undefined : ShipmentStateFromJSON(json["state"]),
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    booked: json["booked"] == null ? undefined : json["booked"],
    deletedDescription:
      json["deletedDescription"] == null
        ? undefined
        : json["deletedDescription"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    quotedAt: json["quotedAt"] == null ? undefined : json["quotedAt"],
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    pickupDateDescription:
      json["pickupDateDescription"] == null
        ? undefined
        : json["pickupDateDescription"],
    distanceMiles:
      json["distanceMiles"] == null ? undefined : json["distanceMiles"],
    companyName: json["companyName"] == null ? undefined : json["companyName"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    companyLeadSource:
      json["companyLeadSource"] == null ? undefined : json["companyLeadSource"],
    companyUtmCampaignId:
      json["companyUtmCampaignId"] == null
        ? undefined
        : json["companyUtmCampaignId"],
    companyCreationDate:
      json["companyCreationDate"] == null
        ? undefined
        : json["companyCreationDate"],
    numberOfShipmentsCompanyBooked:
      json["numberOfShipmentsCompanyBooked"] == null
        ? undefined
        : json["numberOfShipmentsCompanyBooked"],
    companyShipmentFrequency:
      json["companyShipmentFrequency"] == null
        ? undefined
        : json["companyShipmentFrequency"],
    numberCustomerInvoices:
      json["numberCustomerInvoices"] == null
        ? undefined
        : json["numberCustomerInvoices"],
    numberCarrierInvoices:
      json["numberCarrierInvoices"] == null
        ? undefined
        : json["numberCarrierInvoices"],
    numberCarrierCreditNotes:
      json["numberCarrierCreditNotes"] == null
        ? undefined
        : json["numberCarrierCreditNotes"],
    moneyInCad: json["moneyInCad"] == null ? undefined : json["moneyInCad"],
    moneyOutCad: json["moneyOutCad"] == null ? undefined : json["moneyOutCad"],
    originalQuote:
      json["originalQuote"] == null ? undefined : json["originalQuote"],
    settlementStatus:
      json["settlementStatus"] == null
        ? undefined
        : ShipmentReportSettlementStatusFromJSON(json["settlementStatus"]),
    profit: json["profit"] == null ? undefined : json["profit"],
    invoiceWarningState:
      json["invoiceWarningState"] == null
        ? undefined
        : ShipmentReportInvoiceWarningStateFromJSON(
            json["invoiceWarningState"],
          ),
    pickupPostalCode:
      json["pickupPostalCode"] == null ? undefined : json["pickupPostalCode"],
    pickupCity: json["pickupCity"] == null ? undefined : json["pickupCity"],
    pickupState: json["pickupState"] == null ? undefined : json["pickupState"],
    pickupCityState:
      json["pickupCityState"] == null ? undefined : json["pickupCityState"],
    pickupCountry:
      json["pickupCountry"] == null
        ? undefined
        : CountryCodeFromJSON(json["pickupCountry"]),
    pickupLat: json["pickupLat"] == null ? undefined : json["pickupLat"],
    pickupLng: json["pickupLng"] == null ? undefined : json["pickupLng"],
    deliveryPostalCode:
      json["deliveryPostalCode"] == null
        ? undefined
        : json["deliveryPostalCode"],
    deliveryCityState:
      json["deliveryCityState"] == null ? undefined : json["deliveryCityState"],
    deliveryState:
      json["deliveryState"] == null ? undefined : json["deliveryState"],
    deliveryCountry:
      json["deliveryCountry"] == null
        ? undefined
        : CountryCodeFromJSON(json["deliveryCountry"]),
    deliveryCity:
      json["deliveryCity"] == null ? undefined : json["deliveryCity"],
    deliveryLat: json["deliveryLat"] == null ? undefined : json["deliveryLat"],
    deliveryLng: json["deliveryLng"] == null ? undefined : json["deliveryLng"],
    quotes:
      json["quotes"] == null
        ? undefined
        : (json["quotes"] as Array<any>).map(
            ShipmentReportQuoteSummaryFromJSON,
          ),
    fastestQuote:
      json["fastestQuote"] == null
        ? undefined
        : ShipmentReportQuoteSummaryFromJSON(json["fastestQuote"]),
    lowestQuote:
      json["lowestQuote"] == null
        ? undefined
        : ShipmentReportQuoteSummaryFromJSON(json["lowestQuote"]),
    bookedQuote:
      json["bookedQuote"] == null
        ? undefined
        : ShipmentReportQuoteSummaryFromJSON(json["bookedQuote"]),
    manualQuotingRequested:
      json["manualQuotingRequested"] == null
        ? undefined
        : json["manualQuotingRequested"],
    lineItems:
      json["lineItems"] == null
        ? undefined
        : (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    lineItemDescription:
      json["lineItemDescription"] == null
        ? undefined
        : json["lineItemDescription"],
    totalHandlingUnits:
      json["totalHandlingUnits"] == null
        ? undefined
        : json["totalHandlingUnits"],
    totalWeight: json["totalWeight"] == null ? undefined : json["totalWeight"],
    totalVolume: json["totalVolume"] == null ? undefined : json["totalVolume"],
    density: json["density"] == null ? undefined : json["density"],
    freightClass:
      json["freightClass"] == null ? undefined : json["freightClass"],
    insuranceRequested:
      json["insuranceRequested"] == null
        ? undefined
        : json["insuranceRequested"],
    insuranceAmount:
      json["insuranceAmount"] == null ? undefined : json["insuranceAmount"],
    insuranceCurrency:
      json["insuranceCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["insuranceCurrency"]),
    standardDryVanLinearFeet:
      json["standardDryVanLinearFeet"] == null
        ? undefined
        : json["standardDryVanLinearFeet"],
    needsDeliveryAppointment:
      json["needsDeliveryAppointment"] == null
        ? undefined
        : json["needsDeliveryAppointment"],
    needsLiftgatePickup:
      json["needsLiftgatePickup"] == null
        ? undefined
        : json["needsLiftgatePickup"],
    needsLiftgateDelivery:
      json["needsLiftgateDelivery"] == null
        ? undefined
        : json["needsLiftgateDelivery"],
    needsResidentialPickup:
      json["needsResidentialPickup"] == null
        ? undefined
        : json["needsResidentialPickup"],
    needsResidentialDelivery:
      json["needsResidentialDelivery"] == null
        ? undefined
        : json["needsResidentialDelivery"],
    needsInsidePickup:
      json["needsInsidePickup"] == null ? undefined : json["needsInsidePickup"],
    needsInsideDelivery:
      json["needsInsideDelivery"] == null
        ? undefined
        : json["needsInsideDelivery"],
    bookedAt: json["bookedAt"] == null ? undefined : json["bookedAt"],
    problems: json["problems"] == null ? undefined : json["problems"],
    tags: json["tags"] == null ? undefined : json["tags"],
    insurancePriceCad:
      json["insurancePriceCad"] == null ? undefined : json["insurancePriceCad"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    linearFeetOverride:
      json["linearFeetOverride"] == null
        ? undefined
        : json["linearFeetOverride"],
    margin: json["margin"] == null ? undefined : json["margin"],
    marginInsuranceFree:
      json["marginInsuranceFree"] == null
        ? undefined
        : json["marginInsuranceFree"],
    pickupReferenceNumber:
      json["pickupReferenceNumber"] == null
        ? undefined
        : json["pickupReferenceNumber"],
    deliveryReferenceNumber:
      json["deliveryReferenceNumber"] == null
        ? undefined
        : json["deliveryReferenceNumber"],
    carrierPickupNumber:
      json["carrierPickupNumber"] == null
        ? undefined
        : json["carrierPickupNumber"],
    trackingId: json["trackingId"] == null ? undefined : json["trackingId"],
    emergencyContactName:
      json["emergencyContactName"] == null
        ? undefined
        : json["emergencyContactName"],
    emergencyContactPhoneNumber:
      json["emergencyContactPhoneNumber"] == null
        ? undefined
        : json["emergencyContactPhoneNumber"],
    pickupBoothNumber:
      json["pickupBoothNumber"] == null ? undefined : json["pickupBoothNumber"],
    deliveryBoothNumber:
      json["deliveryBoothNumber"] == null
        ? undefined
        : json["deliveryBoothNumber"],
    advanceInterlineProNumber:
      json["advanceInterlineProNumber"] == null
        ? undefined
        : json["advanceInterlineProNumber"],
    beyondInterlineProNumber:
      json["beyondInterlineProNumber"] == null
        ? undefined
        : json["beyondInterlineProNumber"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    bookedBy: json["bookedBy"] == null ? undefined : json["bookedBy"],
    actualDeliveryDate:
      json["actualDeliveryDate"] == null
        ? undefined
        : json["actualDeliveryDate"],
    pickupBusinessName:
      json["pickupBusinessName"] == null
        ? undefined
        : json["pickupBusinessName"],
    pickupLocationType:
      json["pickupLocationType"] == null
        ? undefined
        : json["pickupLocationType"],
    pickupNotes: json["pickupNotes"] == null ? undefined : json["pickupNotes"],
    pickupAddress1:
      json["pickupAddress1"] == null ? undefined : json["pickupAddress1"],
    pickupAddress2:
      json["pickupAddress2"] == null ? undefined : json["pickupAddress2"],
    deliveryBusinessName:
      json["deliveryBusinessName"] == null
        ? undefined
        : json["deliveryBusinessName"],
    deliveryLocationType:
      json["deliveryLocationType"] == null
        ? undefined
        : json["deliveryLocationType"],
    deliveryNotes:
      json["deliveryNotes"] == null ? undefined : json["deliveryNotes"],
    deliveryAddress1:
      json["deliveryAddress1"] == null ? undefined : json["deliveryAddress1"],
    deliveryAddress2:
      json["deliveryAddress2"] == null ? undefined : json["deliveryAddress2"],
    companyFirstQuotedAt:
      json["companyFirstQuotedAt"] == null
        ? undefined
        : json["companyFirstQuotedAt"],
    dangerous: json["dangerous"] == null ? undefined : json["dangerous"],
    protectFromFreezing:
      json["protectFromFreezing"] == null
        ? undefined
        : json["protectFromFreezing"],
    invoiceAuditExisted:
      json["invoiceAuditExisted"] == null
        ? undefined
        : json["invoiceAuditExisted"],
    invoiceAuditOpen:
      json["invoiceAuditOpen"] == null ? undefined : json["invoiceAuditOpen"],
    pickupDistributionWarehouseBrand:
      json["pickupDistributionWarehouseBrand"] == null
        ? undefined
        : json["pickupDistributionWarehouseBrand"],
    deliveryDistributionWarehouseBrand:
      json["deliveryDistributionWarehouseBrand"] == null
        ? undefined
        : json["deliveryDistributionWarehouseBrand"],
    pickupRegion:
      json["pickupRegion"] == null ? undefined : json["pickupRegion"],
    deliveryRegion:
      json["deliveryRegion"] == null ? undefined : json["deliveryRegion"],
    pickupSubregion:
      json["pickupSubregion"] == null ? undefined : json["pickupSubregion"],
    deliverySubregion:
      json["deliverySubregion"] == null ? undefined : json["deliverySubregion"],
    pickupMetroArea:
      json["pickupMetroArea"] == null ? undefined : json["pickupMetroArea"],
    deliveryMetroArea:
      json["deliveryMetroArea"] == null ? undefined : json["deliveryMetroArea"],
    opportunityCad:
      json["opportunityCad"] == null ? undefined : json["opportunityCad"],
    earliestTransitDaysAtQuoting:
      json["earliestTransitDaysAtQuoting"] == null
        ? undefined
        : json["earliestTransitDaysAtQuoting"],
    latestTransitDaysAtQuoting:
      json["latestTransitDaysAtQuoting"] == null
        ? undefined
        : json["latestTransitDaysAtQuoting"],
    actualTransitDays:
      json["actualTransitDays"] == null ? undefined : json["actualTransitDays"],
    transitTimeSource:
      json["transitTimeSource"] == null
        ? undefined
        : TransitTimeSourceTypeFromJSON(json["transitTimeSource"]),
    longestDimensionInches:
      json["longestDimensionInches"] == null
        ? undefined
        : json["longestDimensionInches"],
    quoteQualityScore:
      json["quoteQualityScore"] == null ? undefined : json["quoteQualityScore"],
    couponUsedAmount:
      json["couponUsedAmount"] == null ? undefined : json["couponUsedAmount"],
    additionalChargeApplied:
      json["additionalChargeApplied"] == null
        ? undefined
        : json["additionalChargeApplied"],
    bookedAtAssignedTo:
      json["bookedAtAssignedTo"] == null
        ? undefined
        : json["bookedAtAssignedTo"],
    shipmentEverHadClaim:
      json["shipmentEverHadClaim"] == null
        ? undefined
        : json["shipmentEverHadClaim"],
    shipmentCurrentlyHasOpenClaim:
      json["shipmentCurrentlyHasOpenClaim"] == null
        ? undefined
        : json["shipmentCurrentlyHasOpenClaim"],
    targetFreightMargin:
      json["targetFreightMargin"] == null
        ? undefined
        : json["targetFreightMargin"],
    perfect: json["perfect"] == null ? undefined : json["perfect"],
    imperfectionReasons:
      json["imperfectionReasons"] == null
        ? undefined
        : json["imperfectionReasons"],
    insuranceCostCad:
      json["insuranceCostCad"] == null ? undefined : json["insuranceCostCad"],
    erapPlanNumber:
      json["erapPlanNumber"] == null ? undefined : json["erapPlanNumber"],
    erapPhoneNumber:
      json["erapPhoneNumber"] == null ? undefined : json["erapPhoneNumber"],
    tdgResponsibleName:
      json["tdgResponsibleName"] == null
        ? undefined
        : json["tdgResponsibleName"],
    shipment: ShipmentFromJSON(json["shipment"]),
  };
}

export function ShipmentReportWithShipmentToJSON(
  json: any,
): ShipmentReportWithShipment {
  return ShipmentReportWithShipmentToJSONTyped(json, false);
}

export function ShipmentReportWithShipmentToJSONTyped(
  value?: ShipmentReportWithShipment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    shipmentHash: value["shipmentHash"],
    state: ShipmentStateToJSON(value["state"]),
    createdAt: value["createdAt"],
    booked: value["booked"],
    deletedDescription: value["deletedDescription"],
    proNumber: value["proNumber"],
    carrierIdentifier: value["carrierIdentifier"],
    quotedAt: value["quotedAt"],
    pickupDate: value["pickupDate"],
    pickupDateDescription: value["pickupDateDescription"],
    distanceMiles: value["distanceMiles"],
    companyName: value["companyName"],
    companyId: value["companyId"],
    companyLeadSource: value["companyLeadSource"],
    companyUtmCampaignId: value["companyUtmCampaignId"],
    companyCreationDate: value["companyCreationDate"],
    numberOfShipmentsCompanyBooked: value["numberOfShipmentsCompanyBooked"],
    companyShipmentFrequency: value["companyShipmentFrequency"],
    numberCustomerInvoices: value["numberCustomerInvoices"],
    numberCarrierInvoices: value["numberCarrierInvoices"],
    numberCarrierCreditNotes: value["numberCarrierCreditNotes"],
    moneyInCad: value["moneyInCad"],
    moneyOutCad: value["moneyOutCad"],
    originalQuote: value["originalQuote"],
    settlementStatus: ShipmentReportSettlementStatusToJSON(
      value["settlementStatus"],
    ),
    profit: value["profit"],
    invoiceWarningState: ShipmentReportInvoiceWarningStateToJSON(
      value["invoiceWarningState"],
    ),
    pickupPostalCode: value["pickupPostalCode"],
    pickupCity: value["pickupCity"],
    pickupState: value["pickupState"],
    pickupCityState: value["pickupCityState"],
    pickupCountry: CountryCodeToJSON(value["pickupCountry"]),
    pickupLat: value["pickupLat"],
    pickupLng: value["pickupLng"],
    deliveryPostalCode: value["deliveryPostalCode"],
    deliveryCityState: value["deliveryCityState"],
    deliveryState: value["deliveryState"],
    deliveryCountry: CountryCodeToJSON(value["deliveryCountry"]),
    deliveryCity: value["deliveryCity"],
    deliveryLat: value["deliveryLat"],
    deliveryLng: value["deliveryLng"],
    quotes:
      value["quotes"] == null
        ? undefined
        : (value["quotes"] as Array<any>).map(ShipmentReportQuoteSummaryToJSON),
    fastestQuote: ShipmentReportQuoteSummaryToJSON(value["fastestQuote"]),
    lowestQuote: ShipmentReportQuoteSummaryToJSON(value["lowestQuote"]),
    bookedQuote: ShipmentReportQuoteSummaryToJSON(value["bookedQuote"]),
    manualQuotingRequested: value["manualQuotingRequested"],
    lineItems:
      value["lineItems"] == null
        ? undefined
        : (value["lineItems"] as Array<any>).map(LineItemToJSON),
    lineItemDescription: value["lineItemDescription"],
    totalHandlingUnits: value["totalHandlingUnits"],
    totalWeight: value["totalWeight"],
    totalVolume: value["totalVolume"],
    density: value["density"],
    freightClass: value["freightClass"],
    insuranceRequested: value["insuranceRequested"],
    insuranceAmount: value["insuranceAmount"],
    insuranceCurrency: CurrencyCodeToJSON(value["insuranceCurrency"]),
    standardDryVanLinearFeet: value["standardDryVanLinearFeet"],
    needsDeliveryAppointment: value["needsDeliveryAppointment"],
    needsLiftgatePickup: value["needsLiftgatePickup"],
    needsLiftgateDelivery: value["needsLiftgateDelivery"],
    needsResidentialPickup: value["needsResidentialPickup"],
    needsResidentialDelivery: value["needsResidentialDelivery"],
    needsInsidePickup: value["needsInsidePickup"],
    needsInsideDelivery: value["needsInsideDelivery"],
    bookedAt: value["bookedAt"],
    problems: value["problems"],
    tags: value["tags"],
    insurancePriceCad: value["insurancePriceCad"],
    serviceIdentifier: value["serviceIdentifier"],
    billOfLadingNumber: value["billOfLadingNumber"],
    linearFeetOverride: value["linearFeetOverride"],
    margin: value["margin"],
    marginInsuranceFree: value["marginInsuranceFree"],
    pickupReferenceNumber: value["pickupReferenceNumber"],
    deliveryReferenceNumber: value["deliveryReferenceNumber"],
    carrierPickupNumber: value["carrierPickupNumber"],
    trackingId: value["trackingId"],
    emergencyContactName: value["emergencyContactName"],
    emergencyContactPhoneNumber: value["emergencyContactPhoneNumber"],
    pickupBoothNumber: value["pickupBoothNumber"],
    deliveryBoothNumber: value["deliveryBoothNumber"],
    advanceInterlineProNumber: value["advanceInterlineProNumber"],
    beyondInterlineProNumber: value["beyondInterlineProNumber"],
    createdBy: value["createdBy"],
    bookedBy: value["bookedBy"],
    actualDeliveryDate: value["actualDeliveryDate"],
    pickupBusinessName: value["pickupBusinessName"],
    pickupLocationType: value["pickupLocationType"],
    pickupNotes: value["pickupNotes"],
    pickupAddress1: value["pickupAddress1"],
    pickupAddress2: value["pickupAddress2"],
    deliveryBusinessName: value["deliveryBusinessName"],
    deliveryLocationType: value["deliveryLocationType"],
    deliveryNotes: value["deliveryNotes"],
    deliveryAddress1: value["deliveryAddress1"],
    deliveryAddress2: value["deliveryAddress2"],
    companyFirstQuotedAt: value["companyFirstQuotedAt"],
    dangerous: value["dangerous"],
    protectFromFreezing: value["protectFromFreezing"],
    invoiceAuditExisted: value["invoiceAuditExisted"],
    invoiceAuditOpen: value["invoiceAuditOpen"],
    pickupDistributionWarehouseBrand: value["pickupDistributionWarehouseBrand"],
    deliveryDistributionWarehouseBrand:
      value["deliveryDistributionWarehouseBrand"],
    pickupRegion: value["pickupRegion"],
    deliveryRegion: value["deliveryRegion"],
    pickupSubregion: value["pickupSubregion"],
    deliverySubregion: value["deliverySubregion"],
    pickupMetroArea: value["pickupMetroArea"],
    deliveryMetroArea: value["deliveryMetroArea"],
    opportunityCad: value["opportunityCad"],
    earliestTransitDaysAtQuoting: value["earliestTransitDaysAtQuoting"],
    latestTransitDaysAtQuoting: value["latestTransitDaysAtQuoting"],
    actualTransitDays: value["actualTransitDays"],
    transitTimeSource: TransitTimeSourceTypeToJSON(value["transitTimeSource"]),
    longestDimensionInches: value["longestDimensionInches"],
    quoteQualityScore: value["quoteQualityScore"],
    couponUsedAmount: value["couponUsedAmount"],
    additionalChargeApplied: value["additionalChargeApplied"],
    bookedAtAssignedTo: value["bookedAtAssignedTo"],
    shipmentEverHadClaim: value["shipmentEverHadClaim"],
    shipmentCurrentlyHasOpenClaim: value["shipmentCurrentlyHasOpenClaim"],
    targetFreightMargin: value["targetFreightMargin"],
    perfect: value["perfect"],
    imperfectionReasons: value["imperfectionReasons"],
    insuranceCostCad: value["insuranceCostCad"],
    erapPlanNumber: value["erapPlanNumber"],
    erapPhoneNumber: value["erapPhoneNumber"],
    tdgResponsibleName: value["tdgResponsibleName"],
    shipment: ShipmentToJSON(value["shipment"]),
  };
}
